import { stringifyQS } from '../../../utils';

import categoriesByLocation from '../data/categoriesByLocation';
import descriptionByLocation from '../data/descriptionByLocation';

// Apply either lat/lng and radius or viewport params
const updateQuery = (query, location) => {
  if (location.coordinate) {
    return {
      ...query,
      locationName: location.name,
      locationLat: location.coordinate.latitude,
      locationLong: location.coordinate.longitude,
      locationSearchRadius: 50,
    };
  } else if (location.viewport) {
    return {
      ...query,
      locationName: location.name,
      viewportNorthEastLat: location.viewport.northEastLat,
      viewportNorthEastLong: location.viewport.northEastLong,
      viewportSouthWestLat: location.viewport.southWestLat,
      viewportSouthWestLong: location.viewport.southWestLong,
    };
  }
  return query;
};

export const applyLocationToData = (sportData, location) => ({
  ...sportData,

  // Check for location-specific description, or use default
  description: descriptionByLocation[`${sportData.permalink}/in-${location.slug}`] || undefined,

  // Attach location object for use in component
  withLocation: location,

  // Append location to title and links
  permalink: `${sportData.permalink}/in-${location.slug}`,
  searchLink: `/s?${stringifyQS(updateQuery(sportData.query, location))}`,

  // Remove hreflang tags, location pages don't have locale variations
  meta: {
    ...sportData.meta,
    title: sportData.meta.title.replace('near me', `in ${location.name}`),
    hrefLang: undefined,
  },

  // If this sport is a filter, append the location to it's parent reference
  ...(sportData.parent && {
    parent: {
      ...sportData.parent,
      permalink: `${sportData.parent.permalink}/in-${location.slug}`,
    },
  }),

  // If this sport has filters, update their permalinks
  // TODO: this could be recursive?
  ...(sportData.filters && {
    filters: Object.keys(sportData.filters).reduce((filters, key) => {
      const filter = sportData.filters[key];
      const locationCategories = categoriesByLocation[location.slug] || [];
      if (locationCategories.includes(filter.permalink.slice(1))) {
        return {
          ...filters,
          [key]: {
            ...filter,
            permalink: `${filter.permalink}/in-${location.slug}`,
          },
        };
      }
      return filters;
    }, {}),
  }),

  allCategories: categoriesByLocation[location.slug].map(category => `/${location.iso2.toLowerCase()}/${category}/in-${location.slug}`),

  // For all lists, append location information
  // TODO: see above, recursive?
  lists: sportData.lists.map(list => ({
    ...list,
    title: `${list.title} in ${location.name}`,
    permalink: list.permalink ? `${list.permalink}/in-${location.slug}` : list.permalink,
    query: updateQuery(list.query, location),
    searchLink: `/s?${stringifyQS(updateQuery(list.query, location))}`,
  })),

  // Update links to other sports with location
  otherSports: sportData.otherSports.map(other => ({
    ...other,
    permalink: `${other.permalink}/in-${location.slug}`,
    title: `${other.title} in ${location.name}`,
  })),
});

export const applyViewPortToData = (sportData, viewport) => ({
  ...sportData,

  // Append location to search link
  searchLink: `/s?${stringifyQS({ ...sportData.query, ...viewport })}`,

  // For all lists, append location information
  // TODO: see above, recursive?
  lists: sportData.lists.map(list => ({
    ...list,
    query: { ...list.query, ...viewport },
    searchLink: `/s?${stringifyQS({ ...list.query, ...viewport })}`,
  })),
});



// WEBPACK FOOTER //
// ./app/src/components/Discovery/helpers/applyLocationToData.js